import { gql } from '@apollo/client'

export const DELETE_GUIA_MUTATION = gql`
  mutation deleteGuiasCliente($input: GuiasClienteInput!) {
    deleteGuiasCliente(input: $input)
  }
`
